// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"3182085c","846":"6a075b97","906":"a09050a1"}[chunkId] + ".chunk.js";
};